module.exports = __webpack_public_path__ + "img/print-maker-1440.332bef0f.jpg";